import type { QueryClient } from '@tanstack/react-query';

import { hasPermission } from '@/entities/practice-member';

type BeforeLoadArgs = {
    context: { queryClient: QueryClient };
};

export async function dashboardBeforeLoad({ context }: BeforeLoadArgs) {
    return { hasEhrAccess: await hasPermission(context.queryClient, ['CLINICIAN', 'EHR_BASE']) };
}
